<template>
    <CCard>      
        <CCardBody>
             <CRow>
                <div class="col-lg-12 control-section">
                    日期 : <ejs-datepicker  id="datepicker" format="yyyy-MM-dd" style='text-align:center' width='200px' v-model="e_sdate" ></ejs-datepicker>~<ejs-datepicker  id="datepicker" format="yyyy-MM-dd" style='text-align:center' width='200px' v-model="e_edate" ></ejs-datepicker>&nbsp;&nbsp;<ejs-button :isPrimary="true" v-on:click.native='getworkpot'>查詢</ejs-button>   
                </div>
             </CRow>
            <CRow>                     
                <div class="col-lg-12 control-section">
                    <div class="content-wrapper">
                      <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='grid' locale='zh-TW' :dataSource="datas" height='500' :allowExcelExport='true' :allowSelection="true"
                                :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :toolbar='toolbar' 
                                :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings'  :queryCellInfo='onQueryCellInfo' 
                                :load='load' :toolbarClick="toolbarClick" :rowSelected='rowSelected' :recordDoubleClick="pubDoubleClick"  >
                                <e-columns>
                                    <e-column type="checkbox" :allowFiltering="false" :allowSorting="false" width="60"></e-column>
                                    <e-column field='day' isPrimaryKey="true" headerText='生產日期' aria-required="true" format='yyyy-MM-dd' width='130'></e-column>                  
                                    <e-column field='sign1' headerText='生產組組長' width='80'></e-column>
                                    <e-column field='sign2' headerText='包裝班長' width='80' ></e-column>
                                    <e-column field='report' headerText='包裝日報表' width='80' :template="urlTemplate" :allowFiltering='false'></e-column>
                                </e-columns>
                            </ejs-grid>        
                        </ejs-tooltip>
                      </div>                  
                    </div>                      
                </div>
  
            </CRow>

             <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast> 
        </CCardBody>
        <div class="control-section">
            <ejs-dialog ref="dialogSign" showCloseIcon='true' isModal='true' :visible='false' header='簽名' width='600px' closeOnEscape='true' >
                <SignTemplate ref="mySignTemplate" v-on:onSignClose="onSignTemplateItem" style="justify-content: center; "></SignTemplate>
            </ejs-dialog>
        </div>   
    </CCard>
  </template>
  
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
    import Vue from "vue";
    
    import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
    import { L10n, enableRipple  } from '@syncfusion/ej2-base';
    import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
    import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { GridComponent, ColumnsDirective, ColumnDirective, GridPlugin, Selection, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
    import SignTemplate from "./compone/PotConditionSign.vue";
    import zhtwLocalization  from '../language/language.json';
    import { ToastComponent, } from "@syncfusion/ej2-vue-notifications";
    L10n.load(zhtwLocalization);

  
    enableRipple(true);
    Vue.use(DialogPlugin);
    Vue.use(GridPlugin);    
    Vue.use(ButtonPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(NumericTextBoxPlugin );
    Vue.use(RadioButtonPlugin);
    Vue.use(TooltipPlugin);
    Vue.prototype.$eventHub = new Vue(); 

    export default Vue.extend({     
        data: function() {
            return {
                //Sin
                ChartdialogButtons: [
                { click: this.dlgButtonClose, buttonModel: { content: '關閉' } }],
                //toast
                position: { X: 'Right', Y: "Bottom" },
                //datepicker
                e_sdate:new Date(2025, 7, 17),
                e_edate:new Date(),
                datas : [],
                pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
                toolbar: [
                    { text: '生產組組長', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Sign1', disabled: localStorage.getItem('report').indexOf('42') < 0  },
                    { text: '包裝班長', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Sign2', disabled: localStorage.getItem('report').indexOf('43') < 0  },
                    { text: '匯出Excel', tooltipText: '匯出Excel', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },
                    'Search'],     
                filterSettings: { type: 'CheckBox' },
                selectionSettings: {  type: 'Multiple', persistSelection: true },
                visible : false,
                urlTemplate: function () {
                    return {
                        template: Vue.component('yesnoTemplate', {
                            template: `<div id="coordinates">
                                    <span id="locationtext"><a @click="doSomething" href="#" ><img src="img/icon/report.png" class="e-image" width="30px" :alt="data.report"/></a></span>        
                                    </div>`,
                            data: function () { return { data: {} }; },
                            methods: { 
                                doSomething(e) {
                                    e.preventDefault(); 
                                    this.$eventHub.$emit('reportWeight',this.data);                               
                                } 
                            }                         
                        })
                    }
                },
            };
        },         
    components: {
        'ejs-grid': GridComponent,
        'ejs-datepicker': DatePickerComponent,
        'ejs-toast': ToastComponent,
        "e-columns":ColumnsDirective,
        "e-column":ColumnDirective,
        SignTemplate
    },
    created(){
        this.getworkpot();
        this.$eventHub.$on('sign', ()=>{ 
        this.$refs.dialogSign.show();
      }); 
        this.$eventHub.$on('reportWeight', (e)=>{ 
            this.onReport(e);
      }); 
    },
    beforeDestroy() {
        this.$eventHub.$off('sign');
        this.$eventHub.$off('reportWeight');
    },
    methods: {   
        onReport: function(e) { 
            // console.log("e",e.signID)
            // return
            fetch(Vue.prototype.GLOBAL.baseURL+`Report/Weight?SignID=${e.signID}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                })
            .then(res => res.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${this.formatDate(new Date(e.day))} 包裝日報表`; // 留空，瀏覽器就會使用後端回傳的 Content-Disposition 檔名
                document.body.appendChild(a);
                a.click();
                a.remove();

                URL.revokeObjectURL(url);
            });
        },
        onQueryCellInfo(args) {     
            if (args.cell) {
                args.cell.classList.add("tooltip-cell");
                args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
            }
        },
        onSignTemplateItem:function() {
            this.$refs.dialogSign.hide(); 
             this.getworkpot();
        },
        //search
        addSign: function(arg) {
            this.axios({
                method: 'post',
                baseURL: Vue.prototype.GLOBAL.baseURL,
                url: `/Report/Weight`,
                headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
                data:{
                    id:this.$refs.grid.getSelectedRecords().map(row => row.signID),
                    type:arg
                }
            })
            .then((response) => {       
                if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
                 this.$refs.toastRef.show( { title: '訊息!', content: "簽名成功", cssClass: 'e-toast-info', icon: 'e-warning toast-icons' });
                this.getworkpot();
            })
            .catch((error) => { 
                this.showError(error, true) }
            )                 
           
        },
        getworkpot:function(){
            this.axios({
                method: 'get',
                baseURL: Vue.prototype.GLOBAL.baseURL,
                url: `/Report/GetWeight?b=${this.e_sdate.toISOString().split('T')[0]}&e=${this.e_edate.toISOString().split('T')[0]}`,
                headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            })
            .then((response) => {       
                if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
                  this.datas = response.data.datas.map(item => ({
                ...item,
                day: item.day ? new Date(item.day) : null
                }));
                console.log(response.data.datas)
            })
            .catch((error) => { 
                this.showError(error, true) }
            )                 
        },        
        beforeRender: function (args) {
            if (args.target.closest("td")) {
                this.$refs.tooltip.content = args.target.innerText;                
            }
        },   
        pubDoubleClick: function () {  
            
        },
        editOkClick: function () {           
            this.upData();         
        },
        valueChange: function () {  
            this.isDataChanged = true;
            this.stTime = null;
        },
        load: function() {   
  
        },       
        addAction: function() {
  
        },      
        sign: function() {
            this.$refs.dialogSign.show();
        },  
        toolbarClick: function(args) {

            if (args.item.id == "Sign1") {
                this.$swal({
                    title: `確認是否進行生產組組長簽核?`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: '是',
                    cancelButtonText: '否'
                }).then((result) => {
                if (result.isConfirmed) {     
                    this.addSign(1);
                } else {
                    return; 
                }
                });
            }
            if (args.item.id == "Sign2") {
                this.$swal({
                    title: `確認是否進行包裝班長簽核?`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: '是',
                    cancelButtonText: '否'
                }).then((result) => {
                if (result.isConfirmed) {     
                    this.addSign(2);
                } else {
                    return; 
                }
                });
            }
            if (args.item.id == "Export") {
              this.$refs.grid.excelExport({fileName: this.formatDate(new Date())+'包裝日報表.xlsx'});
            }
        },   
  
        actionComplete: function() {                             
        },
        rowSelected: function() {          
        },
        formatDate(date) {
            let yyyy = date.getFullYear();
            let mm = String(date.getMonth() + 1).padStart(2, '0');      
            let dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },   
        showError: function(error) {
            if (error.response.status == 400) {
                for(var key in error.response.data.errors){                 
                    this.$toast.open({message: error.response.data.errors[key][0] , type: "warning", duration: 5000, dismissible: true}) 
                }
                return;
            }    
            if (error.response.status == 401) {  
                localStorage.removeItem('token'); this.$router.push('/login'); 
                return; 
            }                
            this.$toast.open({message: '系統發生錯誤' + error.response.status, type: "error", duration: 5000, dismissible: true}) 
        }
    },

    provide: {
        grid: [PdfExport, ExcelExport, Sort, Selection , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search,Selection]      
    }
    });
  </script>
  
